<template>
  <div v-if="preview" class="invitation-banner" data-test="invitation-banner">
    <p class="invitation-banner__title">{{ $t('invitation.title', { org: preview.org_name }) }}</p>
    <p class="invitation-banner__body">
      {{ preview.inviter_name ? $t('invitation.by', { who: preview.inviter_name, org: preview.org_name }) : $t('invitation.anonymous', { org: preview.org_name }) }}
    </p>
  </div>
  <div v-else-if="dead" class="invitation-banner invitation-banner--dead" data-test="invitation-dead">
    <p class="invitation-banner__body">{{ $t('invitation.dead') }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { InvitationPreview } from './invitation';

/** Quién te invita a qué, encima del formulario; o que el enlace ya no vale. */
export default defineComponent({
  name: 'InvitationBanner',
  props: {
    preview: { type: Object as PropType<InvitationPreview | null>, default: null },
    dead: { type: Boolean, default: false },
  },
});
</script>

<style scoped>
.invitation-banner {
  margin: 0 0 var(--casa-espacio-5);
  padding: var(--casa-espacio-3-5) var(--casa-espacio-4);
  border: 1px solid var(--ii-rule, #E3E0DC);
  border-left: 3px solid var(--ii-accent, #0A1B3D);
  border-radius: var(--casa-radio-tarjeta);
  background: var(--casa-fondo-app);
}
.invitation-banner--dead { border-left-color: #B3261E; }
.invitation-banner__title { margin: 0 0 var(--casa-espacio-1); font-size: var(--casa-letra-seccion); font-weight: 600; color: var(--ii-ink, #0C0A08); }
.invitation-banner__body { margin: 0; font-size: var(--casa-letra-texto); color: var(--ii-ink-2, #5F5B56); }
</style>
